import React, { Component, Fragment, useState, useEffect } from "react";
import { getUserContent } from "../../Features/SiteSettings/siteSettingSlice";

import Header from "../../components/Header";
import Footer from "../../components/Footer";
import Sidebar from "../../components/Sidebar";
import { useDispatch } from "react-redux";



import { useCustomizeContext } from "../../context";


const About = (props) => {

   let dispatch = useDispatch();

   const {
      loader: {
         setLoading,
      },
      languageContext: {
         language, setLanguage,
         changeLanguageRes, setChangeLanguageRes,
      },
      sideMenu: {
         classIsActive, setClassIsActive
      },
   } = useCustomizeContext();

   const [userAboutRes, setuserAboutRes] = useState("");
   const [contentabt, setContentabt] = useState("");
   const [titleabt, setTitleabt] = useState("");
   const [aboutimg, setAboutimg] = useState();

   useEffect(() => {
      userContent();
   }, [changeLanguageRes]);

   useEffect(() => {
      window.scrollTo(0, 0);
   }, []);

   const userContent = async () => {
      setLoading(true);
      let res = await dispatch(getUserContent({ type: "user" }));

      setTimeout(() => {
         if (res?.status) {
            setuserAboutRes(res?.data);
            setTitleabt(res?.data[0]?.title);
            setContentabt(res?.data[0]?.content);
            setAboutimg(res?.data[0]?.image)
            setLoading(false);
         }
         else {
            setLoading(false);
         }
      }, 1000);
   }

   useEffect(() => {
      document.body.classList.remove("SideMenuOpen");
      setClassIsActive(false);
   }, []);

   return (
      <Fragment>
         <Header />
         <div class="mainbody-content">
            <Sidebar />
            <div class="center-maincnt">
               <div class="inr-container">
                  <div class="center-inrcnt">
                     <div className="aboutuspage-maincnt">

                        <section class="privacy_policy_sec_1">
                           <div class="banner-privacy my-4">

                              <div>
                                 <img src={aboutimg} style={{ width: "840px", height: "166px" }} className="aboutimg" />
                              </div>


                           </div>
                           <div class="pri_pol_cd">
                              <h1 dangerouslySetInnerHTML={{ __html: titleabt }}></h1>
                              <div dangerouslySetInnerHTML={{ __html: contentabt }}></div>

                           </div>
                        </section>
                     </div>
                  </div>
                  <Footer />
               </div>
            </div>
         </div>
      </Fragment>
   );

}

export default About;